"use strict";

exports.__esModule = true;
exports.AlertRoutes = AlertRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _CheckAccessRoute = require("../../Core/CheckAccessRoute/CheckAccessRoute");
var _AlertListScreen = require("../AlertListScreen");
var _AlertWatcherRuleListScreen = require("../AlertWatcherRuleListScreen");
var _Widgets = require("../../Widgets");
var _alertWidgets = require("../../../Utils/alertWidgets");
var _System = require("../../../System");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _UhOh = require("../../Core/UhOh");
var _AlertDetails = require("../AlertDetails");
var _AlertsAnalysisScreen = require("../AlertsAnalisys/AlertsAnalysisScreen");
var _AlertsCreationScreen = require("../AlertsCreation/AlertsCreationScreen");
var _featureFlags = require("../../../featureFlags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// Override global settings for the layout here, see LayoutSettingsController for defaults
var settings = {
  selection: {
    allowReportingPeriod: true
  }
};

/**
 * Routes for the Alerting.
 */
function AlertRoutes(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Provider, settings, /*#__PURE__*/_react["default"].createElement(_Widgets.WidgetsContext.Provider, {
    value: {
      alertWidgets: (0, _alertWidgets.alertWidgets)().filter(function (widget) {
        return !!widget;
      })
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("AlertWatcherRuleList") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_ALERT",
      component: _AlertWatcherRuleListScreen.AlertWatcherRuleListScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("AlertDetails"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_ALERT",
      render: function render(props) {
        var alertId = props.match.params.id;
        if (alertId) {
          return /*#__PURE__*/_react["default"].createElement(_AlertDetails.AlertDetails, _extends({}, props, {
            alertId: alertId,
            isFullScreen: true
          }));
        }
        return /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
          error: new Error("id is undefined")
        });
      }
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("AlertList") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_ALERT",
      component: _AlertListScreen.AlertListScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("AlertsAnalysis"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_ALERT",
      featureFlag: "ENABLE_ALERTS_ANALYSIS",
      component: _AlertsAnalysisScreen.AlertsAnalysisScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("AlertsCreation"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "CREATE_ALERT",
      featureFlag: _featureFlags.ENABLE_ALERTS_CREATION,
      component: _AlertsCreationScreen.AlertsCreationScreen
    })
  })), children));
}